import React from 'react';
import {Alert} from 'react-bootstrap';
import ProblemBadge from './ProblemBadge';
import ActionBadge from './ActionBadge';

const ACTION_LABELS = {
    invoice_correction: 'Déposez une facture corrigée ou une prise en charge valide',
    info_request: 'Répondez à notre demande d\'informations complémentaires',
};

const ActionRequiredCard = ({mailInformation, actionType}) => {
    if (!mailInformation) return null;
    const actionLabel = ACTION_LABELS[actionType];
    return (
        <Alert variant="danger" className="mb-4">
            <div className="alert-message">
                <Alert.Heading className="text-danger">Action requise</Alert.Heading>
                <p className="mb-2">Nous avons détecté un problème qui empêche la validation de votre dossier.</p>
                <p className={actionLabel ? 'mb-2' : 'mb-0'}>
                    <ProblemBadge />{' '}
                    <span style={{whiteSpace: 'pre-line'}}>{mailInformation}</span>
                </p>
                {actionLabel && (
                    <p className="mb-0">
                        <ActionBadge /> {actionLabel}
                    </p>
                )}
            </div>
        </Alert>
    );
};

export default ActionRequiredCard;
